(function () {
  var PLANS_URL = '/pages/4g-unlimited-plan#plans';

  function buildSeePlans() {
    var a = document.createElement('a');
    a.className = 'data-plan-see-plans';
    a.href = PLANS_URL;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'See 4G Unlimited plans and pricing');
    a.innerHTML = '<span>See Plans &amp; Pricing</span><span style="font-size:16px;line-height:1;">&rarr;</span>';
    a.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;margin:10px 0 2px;padding:12px 16px;border:1px solid #e0a340;border-radius:10px;background:transparent;color:#e0a340;font-size:14px;font-weight:600;letter-spacing:.01em;text-decoration:none;cursor:pointer;transition:background .15s,color .15s;';
    a.addEventListener('mouseenter', function () { a.style.background = '#e0a340'; a.style.color = '#0b0c0e'; });
    a.addEventListener('mouseleave', function () { a.style.background = 'transparent'; a.style.color = '#e0a340'; });
    a.addEventListener('click', function (e) { e.stopPropagation(); });
    return a;
  }

  function apply() {
    var accordion = document.querySelector('.wood_hard_select');
    if (!accordion) { return; }

    var summary = accordion.querySelector('summary');
    if (summary && summary.textContent.trim() !== 'Required Cellular Data') {
      summary.textContent = 'Required Cellular Data';
    }

    var trialOption = accordion.querySelector('.wood_hard_select_flex');
    if (!trialOption) { return; }

    var label = trialOption.querySelector('.wood_hard_select_txt');
    var wantedLabelHTML = '<span style="font-size:16px;line-height:20px;display:inline-block;">Free Trial - 100MB Defender Data</span><br><span style="font-size:12px;font-weight:normal;font-style:italic;opacity:0.85;line-height:16px;display:inline-block;margin-top:3px;">Paid plan required upon expiration, only works in Canada. Lasts up to 7 days</span>';
    if (label && label.innerHTML.trim() !== wantedLabelHTML) {
      label.innerHTML = wantedLabelHTML;
      label.style.lineHeight = 'normal';
      label.style.padding = '10px 0';
    }

    var price = trialOption.querySelector('.wood_hard_select_price');
    if (price && price.textContent.trim() !== 'FREE') {
      price.textContent = 'FREE';
    }

    if (!accordion.querySelector('.data-plan-see-plans')) {
      trialOption.insertAdjacentElement('afterend', buildSeePlans());
    }

    if (!trialOption.classList.contains('active')) {
      trialOption.classList.add('active');
      if (window.jQuery) {
        try {
          window.jQuery(trialOption).trigger('click');
        } catch (e) {
        }
      }
    }
  }

  function start() {
    apply();
    var target = document.querySelector('.product_meta_options') || document.querySelector('.wood_hard_select') || document.body;
    var observer = new MutationObserver(function () { apply(); });
    observer.observe(target, { childList: true, subtree: true });
    setTimeout(apply, 300);
    setTimeout(apply, 1000);
    setTimeout(apply, 2500);
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
